class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.body = document.body;
    this.drawer = document.getElementById('cart-drawer');
    
    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));
    
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');

    // On Change
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);

    this.body.classList.add('scroll-lock');
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);

    this.body.classList.remove('scroll-lock');
  }

  onChange(event) {
    console.log(event)
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));

        this.updateValues(parsedState);

        this.disableLoading();
      }).finally(() => {
        const cartUpsellSlider = document.querySelector('.cart-drawer__upsell-items');
        if(cartUpsellSlider) {
          const cartUpsellSwiperInstance = new Swiper(cartUpsellSlider, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
              prevEl: '.cart-upsell-arrow-left',
              nextEl: '.cart-upsell-arrow-right'
            },
            breakpoints: {
              501: {
                slidesPerView: 2,
              }
            }
          })
        }
      }).catch(() => {
        this.disableLoading();
      });
  }

  updateValues(cart) {
    // Cart Counts
    const cartCountEl = this.querySelectorAll('.cart-count');
    cartCountEl.forEach(el => el.innerHTML = cart.item_count );

    // Shipping Threshold
    const shippingThresholdText = document.querySelector('.cart-drawer__threshold-text');
    const shippingThreshold = Number(this.dataset.shipping);
    const shippingBar = this.querySelector('.cart-drawer__threshold-bar-inner');

    if (shippingThreshold) {
      const newShippingThreshold = this.getSectionInnerHTML(cart.sections['cart-drawer'], '.cart-drawer__threshold-text')
      shippingThresholdText.innerHTML = newShippingThreshold;

      // Bar
      if (shippingThreshold > cart.items_subtotal_price) {
        const shippingBarWidth = (cart.items_subtotal_price / shippingThreshold) * 100;
        shippingBar.style.width = `${shippingBarWidth}%`;
      } else {
        shippingBar.style.width = '100%';
      }
    }
  }

  rerender(open) {
    this.enableLoading();

    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateValues(parsedState);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.disableLoading();
      }).catch(() => {
        this.disableLoading();
      }).finally(() => {
        if (open) {
          const cartUpsellSlider = document.querySelector('.cart-drawer__upsell-items');
        if(cartUpsellSlider) {
          const cartUpsellSwiperInstance = new Swiper(cartUpsellSlider, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
              prevEl: '.cart-upsell-arrow-left',
              nextEl: '.cart-upsell-arrow-right'
            },
            breakpoints: {
              501: {
                slidesPerView: 2,
              }
            }
          })
        }
        
          this.open();
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    const loading = document.getElementById('cart-drawer-loading');
    if (loading) {
      loading.classList.remove('hidden')
    }
  }

  disableLoading() {
    const loading = document.getElementById('cart-drawer-loading');
    if (loading) {
      loading.classList.add('hidden')
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }
}

customElements.define('cart-drawer', CartDrawer);
